import { render } from "./BlStandaloneField.vue?vue&type=template&id=a372a4ac&scoped=true"
import script from "./BlStandaloneField.vue?vue&type=script&lang=js"
export * from "./BlStandaloneField.vue?vue&type=script&lang=js"

import "./BlStandaloneField.vue?vue&type=style&index=0&id=a372a4ac&scoped=true&lang=scss"

import exportComponent from "/tmp/7c12f39a-5a06-429e-8ff2-90249d9b2982/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a372a4ac"]])

export default __exports__